@if(!isMobile){
<header class="bg-safety-yellow pt-2 pb-2">
  <div class="px-8">
    <div class="flex justify-between">
      <img
        src="assets/logo-poste-italiane.png"
        alt="Logo Poste Italiane"
        class="block cursor-pointer"
        [ngClass]="{ 'h-4 pl-4': isMobile, 'h-7': !isMobile }"
        (click)="menuSelect('')"
      />

      <div class="flex items-center gap-5">
        <nav>
          <ul class="flex items-center gap-5">
            @for (item of primaryMenu; track $index) {
            <li>
              <a
                (click)="menuSelect(item.id)"
                class="cursor-pointer text-black flex items-center gap-2"
                [title]="item.title || item.label"
              >
                @if(item.icon){
                <img
                  [src]="item.icon"
                  [alt]="item.title || item.label"
                  class="block h-6"
                />
                }
                <span class="text-xl">{{ item.label }}</span>
              </a>
            </li>
            } @if(isSecondLogoVisibile){
            <li>|</li>
            }
          </ul>
        </nav>
        @if(isSecondLogoVisibile){
        <img
          src="assets/logo-punto-poste.png"
          alt="Logo Poste Italiane"
          class="block h-4"
        />
        }
      </div>
    </div>
  </div>
</header>
  @if(showNotificationBanner && isLogged){
    <div class="text-crayola flex pl-2 pt-2 pb-2">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
      </svg>
      <span class="ml-2">{{notificationBannerText}}</span>
    </div>
  }
}

@if (isSecondMenuVisibile) {
<div
  class="pt-2 pb-2"
  [ngClass]="{
    'bg-crayola': !isMobile && isLogged,
    'bg-safety-yellow': isMobile,
  }"
>
  <nav
    [ngClass]="{
      'flex justify-between': isMobile || isBackMenuVisibile,
      'menu--left': isMobile
    }"
    class="px-8"
  >
    @if(isMobile) {
    <div class="flex justify-between items-center w-full my-2 mx-5">
      <div class="menuToggle block relative">
        <input
          type="checkbox"
          class="block w-10 h-8 absolute -top-1.5 cursor-pointer"
          [class.input-checked]="isMobileMenuOpened"
          [disabled]="isMobileMenuOpened"
          [checked]="isMobileMenuOpened"
          (click)="toggleChecked()"
        />
        @if(isMobileMenuOpened){
        <div class="overlay"></div>
        }
        <span></span>
        <span></span>
        <div class="menu-item absolute flex flex-col justify-between">
          <div>
            <div class="menu-mobile-top">
              MENU
              <div (click)="toggleChecked()">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 18 18 6M6 6l12 12"
                  />
                </svg>
              </div>
            </div>
            <ng-content select="[sidebar]"></ng-content>
            @if(secondaryMenu.length){
            <div class="menu-mobile-secondary menu-mobile-border">
              @for (item of secondaryMenu; track $index) {
              <ul>
                <li (click)="menuSelect(item.id)">
                  @if(item.icon && showIconBacheca){
                  <img
                    [src]="item.icon"
                    [alt]="item.title || item.label"
                    class="h-4 pr-4"
                  />
                  } @else {
                  <div class="pr-7"></div>
                  }
                  {{ item.label }}
                </li>
              </ul>
              }
            </div>
            }
            <div class="menu-mobile-secondary border-0">
              @for (item of primaryMenuMobile; track $index) {
              <ul>
                <li (click)="menuSelect(item.id)">
                  @if(item.icon){
                  <img
                    [src]="item.icon"
                    [alt]="item.title || item.label"
                    class="h-4 pr-4"
                  />
                  }
                  {{ item.label }}
                </li>
              </ul>
              }
            </div>
          </div>
          <div class="menu-mobile-bottom">
            <img
              src="assets/logo-poste-italiane.png"
              alt="Logo Poste Italiane"
              class="block cursor-pointer"
              [ngClass]="{ 'h-4 pl-4': isMobile, 'h-7': !isMobile }"
              (click)="menuSelect('')"
            />
          </div>
        </div>
      </div>
      <div>
        <img
          src="assets/logo-poste-italiane.png"
          alt="Logo Poste Italiane"
          class="block cursor-pointer"
          [ngClass]="{ 'h-4 pl-4': isMobile, 'h-7': !isMobile }"
          (click)="menuSelect('')"
        />
      </div>
      <div>
        <img
          src="assets/logo-punto-poste.png"
          alt="Logo Punto Poste"
          class="block cursor-pointer"
          [ngClass]="{ 'h-2': isMobile, 'h-7': !isMobile }"
          (click)="menuSelect('')"
        />
      </div>
    </div>
    } @else if(isBackMenuVisibile) {
    <a
      (click)="menuSelect(backMenuLink)"
      class="cursor-pointer text-white flex items-center gap-2"
      [title]="backMenuLabel"
    >
      <img src="assets/back.png" [alt]="backMenuLabel" class="block h-5" />
      <span class="text-xl leading-none">{{ backMenuLabel | uppercase }}</span>
    </a>
    } @if(!isMobile){
    <ul
      class="flex justify-end items-center gap-10"
      [ngClass]="{ 'pr-6': isMobile }"
    >
      @for (item of secondaryMenu; track $index) {
      <li>
        <a
          (click)="menuSelect(item.id)"
          class="cursor-pointer text-white flex items-center gap-2"
          [title]="item.title || item.label"
        >
          @if(item.icon && showIconBacheca){
          <img
            [src]="item.icon"
            [alt]="item.title || item.label"
            class="block h-5"
          />
          }
          <span class="text-xl">{{ item.label }}</span>
        </a>
      </li>
      }
    </ul>
    }
  </nav>
</div>
@if(isMobile){
  @if(showNotificationBanner  && isLogged){
    <div class="text-crayola flex pl-2 pt-2 pb-2">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
      </svg>
      <span class="ml-2">{{notificationBannerText}}</span>
    </div>
  }
}
}
